const takeDefaultConstants = {
  defaultRecommendedCourseIds: [4506, 4317, 5045, 12179, 5787],
  defaultNewCourseIds: [17311, 17076, 17077, 17078, 17079, 17080, 17081, 17082],
  defaultTopSaleCourseIds: [17143, 22, 3309, 15839, 5, 5045],
  defaultSpecialCourseId: {},
  defaultSpecialCourseIdsInSubscription: {
    17329: 17082
  },
  defaultPaywallServiceId: 343,
  defaultLinkQuiz: 'https://takeclass.io/course/tc_eng_school_up_s_quiz',
  coursesForShowModalNewOffer: [17329],
  coursesForHideModalNewOffer: [17082]
}

export default takeDefaultConstants
